var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button button--raised"},[_c('div',{staticClass:"mdc-button__ripple"}),_c('span',{staticClass:"mdc-button__label"},[_vm._t("default")],2),_c('div',{staticClass:"mdc-button__touch"})])}
var staticRenderFns = []

export { render, staticRenderFns }